import type { ReactNode } from 'react'
import type { NavigateOptions, To } from 'react-router'
import { RightOutlined } from '@ant-design/icons'
import TooltipCol from '@c/tooltip-col'
import icon from '@i/global/u986.png'

export interface MenuItem {
  label: ReactNode
  isMain?: boolean
  divider?: boolean
  hidden?: boolean
  path?: string | { to: To; options?: NavigateOptions }
  children?: MenuItem[]
}

interface MenuProps extends CommonProps {
  title?: ReactNode
  items: MenuItem[]
  onClick?: (item: MenuItem) => void
}

const Menu = ({ className, style, onClick, ...props }: MenuProps) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const menuItems = (items: MenuItem[]) =>
    items.map((item, index) => {
      const menuItemPath = isString(item.path) ? item.path : item.path?.to
      return (
        <div key={index} className={clsx({ hidden: item.hidden })}>
          {item.divider && <div className="mx-3 b-t-1 b-#e8e8e8 b-t-solid" />}
          {isArray(item.label) && item.isMain ? (
            <div className="px-3 text-16px font-bold leading-10">
              <span>{item.label[0]}</span>
              <span className="text-main">{item.label.slice(1, item.label.length)}</span>
            </div>
          ) : (
            <div
              className={clsx(
                'fcb cursor-pointer pl-5 pr-4 text-#666 leading-56px hover:bg-[url(@i/global/22_u42.png)] hover:text-#fff',
                { 'bg-[url(@i/global/22_u42.png)] text-#fff': pathname === menuItemPath }
              )}
              onClick={() => {
                if (!!onClick) {
                  onClick(item)
                } else if (!!item.path) {
                  if (isString(item.path)) navigate(item.path)
                  else navigate(item.path.to, item.path.options)
                }
              }}
            >
              <TooltipCol> {item.label} </TooltipCol>
              <RightOutlined className="text-12px opacity-70" />
            </div>
          )}
          {isArray(item.children) && menuItems(item.children)}
        </div>
      )
    })

  return (
    <div
      className={clsx(
        'h-fit w-251px rounded-2 bg-[length:100%_auto] bg-[position:bottom] bg-[url(@i/global/nav_bg.png)] bg-#fff bg-no-repeat pb-100px text-14px text-#333',
        className
      )}
      style={style}
    >
      {!!props.title && (
        <TooltipCol className="fc b-b-1 b-#ededed b-solid px-4 py-3 font-bold text-main">
          <img className="mr-2" src={icon} />
          {props.title}
        </TooltipCol>
      )}
      <div>{menuItems(props.items)}</div>
    </div>
  )
}
export default Menu
